import { waitForCordovaReady } from 'shared/app/lib/wait-for-cordova';
export async function exitApp() {
    await waitForCordovaReady();
    navigator.app.exitApp();
}
